export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ../~/d3-axis/src/array.js
// module id = KXlw
// module chunks = 0